import { render, staticRenderFns } from "./ForPool.vue?vue&type=template&id=632dd949&scoped=true"
import script from "./ForPool.vue?vue&type=script&lang=js"
export * from "./ForPool.vue?vue&type=script&lang=js"
import style0 from "./ForPool.vue?vue&type=style&index=0&id=632dd949&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632dd949",
  null
  
)

export default component.exports